<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import EmojiPicker from "$components/+blocks/EmojiPicker/EmojiPicker.svelte";
  import { EmojiReaction } from "$components/+blocks/OVIcon";

  const dispatch = createEventDispatcher();

  let viewMode: "closed" | "preview" | "full" = "closed";
</script>

<EmojiPicker
  on:selection={(event) => {
    dispatch("addReaction", event.detail);
  }}
  bind:viewMode
>
  <IconButton
    icon={EmojiReaction}
    variant={viewMode === "full" ? "active" : "primary"}
    size="small"
    a11yLabel={""}
  />
</EmojiPicker>
